module.exports = __webpack_public_path__ + "static/media/kfc.71793dd4.svg";